import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropzone", "input", "list", "rowTemplate"]

  connect() {
    // Array of objects: { file: File, name: String }
    this.selectedFiles = []
  }

  open() {
    this.inputTarget.click()
  }

  dragenter(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add('bg-gray-50', 'border-blue-400')
  }

  dragover(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add('bg-gray-50', 'border-blue-400')
  }

  dragleave(event) {
    if (!this.element.contains(event.relatedTarget)) {
      this.dropzoneTarget.classList.remove('bg-gray-50', 'border-blue-400')
    }
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove('bg-gray-50', 'border-blue-400')
    this.addFiles(Array.from(event.dataTransfer.files))
  }

  change(event) {
    // Ajouter les nouveaux fichiers sélectionnés sans supprimer les anciens
    this.addFiles(Array.from(event.target.files))
    this.dropzoneTarget.classList.remove('bg-gray-50', 'border-blue-400')
  }

  addFiles(newFiles) {
    // Ajouter les nouveaux fichiers à notre liste
    newFiles.forEach(file => {
      this.selectedFiles.push({ file: file, name: file.name })
    })

    this.refreshDisplay()
    this.updateInput()
  }

  refreshDisplay() {
    // Vider l'affichage
    this.listTarget.innerHTML = ''

    // Réafficher tous les fichiers
    this.selectedFiles.forEach((fileObj, index) => {
      this.displayFile(fileObj, index)
    })
  }

  displayFile(fileObj, index) {
    const clone = this.rowTemplateTarget.content.cloneNode(true)
    const row = clone.querySelector('[data-file-row]')
    const nameInput = clone.querySelector('[data-name]')
    const removeButton = clone.querySelector('button')

    row.dataset.fileIndex = index
    nameInput.value = fileObj.name

    nameInput.addEventListener('input', (e) => {
      this.renameFile(index, e.target.value)
    })

    removeButton.addEventListener('click', () => {
      this.removeFile(index)
    })

    this.listTarget.appendChild(clone)
  }

  remove(event) {
    const index = parseInt(event.currentTarget.closest('[data-file-row]').dataset.fileIndex)
    this.removeFile(index)
  }

  removeFile(index) {
    // Supprimer le fichier de notre liste
    this.selectedFiles.splice(index, 1)

    // Supprimer l'affichage
    const row = this.listTarget.querySelector(`[data-file-index="${index}"]`)
    if (row) {
      row.remove()
    }

    // Réindexer les autres fichiers
    this.reindexFiles()

    // Mettre à jour l'input
    this.updateInput()
  }

  reindexFiles() {
    const rows = this.listTarget.querySelectorAll('[data-file-row]')
    rows.forEach((row, newIndex) => {
      row.dataset.fileIndex = newIndex
    })
  }

  renameFile(index, newName) {
    if (this.selectedFiles[index]) {
      this.selectedFiles[index].name = newName
      this.updateInput()
    }
  }

  updateInput() {
    // Créer une nouvelle DataTransfer avec tous nos fichiers
    const dataTransfer = new DataTransfer()
    this.selectedFiles.forEach(fileObj => {
      const renamedFile = new File([fileObj.file], fileObj.name, { type: fileObj.file.type })
      dataTransfer.items.add(renamedFile)
    })

    // Mettre à jour l'input
    this.inputTarget.files = dataTransfer.files
  }
}
